<!-- <audio controls #player="" (ended)="playerEnded('')"> -->
    <audio controls #player (ended)="playerEnded(player.src)">
